import { Link } from 'react-router-dom';
import { brand, brandArt } from '../theme/tokens';

// The v3 brand lockup. Two images, swapped by the theme attribute rather than
// filtered — a CSS filter on a coloured logo muddies the brand colour, so v3 ships
// separate light and reversed artwork and hides one. Both are in the DOM, so the swap
// costs no request when the theme changes. Decoded synchronously (no
// `decoding="async"`): the header logo is above the fold on every page, and an async
// decode could paint the header without it.
export function BrandLockup({ className }: { className?: string }) {
  return (
    <Link to="/" className={className ? `brand ${className}` : 'brand'} aria-label={brand.name}>
      <img data-logo="light" loading="eager" src={brandArt.lockup_light} alt={brand.name} width={148} height={32} />
      <img
        data-logo="dark"
        loading="eager"
        src={brandArt.lockup_dark}
        alt={brand.name}
        width={148}
        height={32}
      />
    </Link>
  );
}
